import { defineStore } from 'pinia';

type ModalType = 'auth' | 'confirm' | 'loader' | 'settings';

export const useModalStore = defineStore('modal', {
  state: () => ({
    modal: {
      type: null as ModalType | null,
      props: {} as Record<string, unknown>,
    },
  }),
  actions: {
    open(type: ModalType, props = {}) {
      this.modal = { type, props };
    },
    setPropField(name: string, value: unknown) {
      this.modal.props[name] = value;
    },
    close(timeout: number = 0) {
      if (timeout <= 0) {
        this.modal = { type: null, props: {} };
        return;
      }

      const modal = this.modal;
      setTimeout((modalStore) => {
        if (modalStore.modal === modal) {
          modalStore.modal = { type: null, props: {} };
        }
      }, timeout, this);
    },
  },
});
